// AUTO-GENERATED by bin/extract_legal_docs.py — do not edit by hand.
// Source: dpa.md (canonical markdown)
// Generated text hash (sha256): 19aa4f29a228783e88167448de5711babe4998a2935acf9cfafacf3c18e06522

const content = `XPERT.COMPANY

operating xpert.company

Data Processing Addendum

B2B + vendor data processing addendum

Version 1.1 · Effective 8 July 2026 · Issued by the Office of the Chief Legal & Compliance Officer (CLCO)

# 1. Parties and incorporation

This Data Processing Addendum ("DPA") forms part of the agreement between Xpert.Company FZ-LLC ("Processor") and the customer or vendor named in the order form or main agreement ("Controller"). Where Xpert.Company processes personal data on behalf of an enterprise buyer, Xpert.Company is the Processor. Where a vendor processes personal data on behalf of Xpert.Company, the vendor is the Processor and Xpert.Company is the Controller; this DPA is mirrored in that direction.

# 2. Definitions

Capitalised terms not defined here have the meanings given in the EU GDPR, the UK GDPR, the UAE PDPL, the DPDPA, or the CCPA/CPRA, as applicable. "Applicable Data Protection Law" means all of the foregoing as they apply to a processing activity.

# 3. Subject matter and details of processing

Item

Particulars

Subject matter

Operation of the xpert.company marketplace for the Controller's authorised users

Duration

Term of the underlying agreement + retention windows in Section 6

Nature and purpose

Account management; booking and matching (including AI-assisted semantic matching and embeddings); payment routing; session video, recording, transcription and AI summarisation (with participant consent); product analytics (consent-gated); error monitoring; and support

Categories of data subjects

Controller's authorised users; Experts engaged through the Controller's account

Categories of personal data

Identity (name, email, phone), account, booking, transaction, communications, session data with consent, device/usage data

Special categories

Not intended; Controller commits not to provide special-category data outside the Service

# 4. Roles and obligations

Processor will process Personal Data only on the documented instructions of the Controller (including this DPA and the underlying agreement) unless compelled by law, in which case it will notify the Controller unless prohibited.

Processor will ensure persons authorised to process Personal Data are under confidentiality obligations.

Processor will implement appropriate technical and organisational measures ("TOMs") set out in Annex II.

Processor will assist the Controller with data subject requests and with Articles 32–36 GDPR obligations (security, breach, DPIAs).

Processor will, at the choice of the Controller, delete or return Personal Data on termination, subject to legal retention obligations.

Processor will make available all information necessary to demonstrate compliance and will allow audits as set out in Section 9.

# 5. Sub-processors

The Controller authorises Processor to engage sub-processors. The current list is at xpert.company/legal/subprocessors and is also Annex III. Processor will give the Controller 30 days' prior notice of any intended change. The Controller may object on reasonable grounds; if it does, the parties will work in good faith to address the objection or the Controller may terminate the affected portion of the agreement. Processor remains liable for sub-processor performance.

# 6. International transfers

Where Personal Data is transferred from the EEA, the UK, the UAE or India to a country without an adequacy decision, the parties incorporate by reference:

The EU Standard Contractual Clauses, with module-appropriate annexes (Annex I lists Module 2 for Controller-to-Processor and Module 3 for Processor-to-Processor cases).

The UK International Data Transfer Agreement or the UK Addendum to the SCCs, as applicable.

UAE PDPL transfer safeguards or any UAE Data Office-approved standard clauses if and when issued.

DPDPA-compliant safeguards for transfers from India.

Each party will conduct a transfer impact assessment for high-risk corridors and document mitigations.

# 7. Security

Processor will maintain the TOMs in Annex II, including encryption in transit and at rest, access controls, MFA on production systems, audit logging, secure SDLC, vulnerability scanning, penetration testing at least annually, vendor management and an incident response plan.

# 8. Personal data breach

Processor will notify the Controller without undue delay and in any event within 24 hours of becoming aware of a Personal Data Breach affecting Controller data, so that the Controller can meet its own notification deadlines (which may be shorter — for example, CERT-In cyber-incident reporting in India can require notification within 6 hours). The notification will describe the nature of the breach, the categories and approximate number of data subjects and records, likely consequences, and measures taken or proposed. Processor will provide updates as more information becomes available and will assist the Controller with regulator and data-subject notifications.

# 9. Audit

Processor will respond to reasonable security questionnaires once per year, and to additional questionnaires on a personal-data breach or material change. The Controller may audit, with at least 30 days' notice, no more than once a year, during business hours, subject to confidentiality and reasonable cost reimbursement. Where Processor holds SOC 2 Type II or ISO 27001 reports, those reports may satisfy the audit obligation.

# 10. Data subject requests

Processor will assist the Controller, by appropriate technical and organisational measures, to respond to data subject requests within the statutory timeframe. Processor will not respond to data subject requests addressed to the Controller, except to confirm the request has been received and forwarded.

# 11. Liability

Each party's liability under this DPA is subject to the limits in the underlying agreement. Nothing in this DPA limits a party's liability for: (a) fines imposed on it directly by a regulator, (b) liability under the SCCs to data subjects, or (c) liability that cannot be limited by Applicable Data Protection Law.

# 12. Term and survival

This DPA is effective for the term of the underlying agreement. Sections 6, 8, 9 and 11 survive termination to the extent of any continuing obligation.

# Annex I — SCC details

Module: 2 (Controller-to-Processor) or 3 (Processor-to-Processor) as applicable.

Data exporter: Controller as identified in the order form.

Data importer: Xpert.Company FZ-LLC.

Competent supervisory authority: Lead DPA in the data exporter's jurisdiction.

Governing law: as specified in the underlying agreement; SCC governing law for the SCCs themselves.

Annex I is completed per the executed order form; where a field is left blank, the details in Sections 3 and 6 and Annex III of this DPA control.

# Annex II — Technical and organisational measures

Information security policies aligned to ISO 27001 Annex A; documented controls.

Access controls: SSO with MFA; least privilege; quarterly access reviews.

Cryptography: TLS 1.2+ in transit; AES-256 at rest; field-level encryption for sensitive identifiers; key rotation.

Network: segmented production VPCs; firewall ingress rules default-deny; egress controls.

Application security: secure SDLC; SAST/DAST; dependency scanning; SBOM.

Logging and monitoring: SIEM; tamper-evident audit logs; 12-month retention.

Vulnerability management: patching SLAs; quarterly internal vulnerability scans; annual independent pen test.

Personnel: background screen; AUP; annual security training; phishing simulation.

Vendor management: DPAs in place; sub-processor list; right-to-audit clauses.

Incident response: documented runbook; PagerDuty; quarterly tabletop.

Business continuity: documented RTO 4h / RPO 1h; tested quarterly.

# Annex III — Sub-processor list (as of effective date)

Sub-processor

Service

Region

Stripe, Inc.

Payments + KYC + Connect

US/EU/IN

Razorpay Software Pvt Ltd

Payments + GST (India)

IN

Daily.co (Pluot Labs, Inc.)

Video + recording + transcripts

US/EU

Supabase, Inc.

Database, authentication, file storage

US/EU

Fly.io (Fly.io, Inc.)

Application hosting / compute

US / multi-region

Google LLC

OAuth sign-in; Calendar/Gmail (only if user connects)

US/EU

Resend (Plus Five Five, Inc.)

Transactional email

US

PostHog, Inc.

Product analytics (consent-gated)

US

Functional Software, Inc. (Sentry)

Error / performance monitoring

US

Anthropic, PBC

LLM (agent reasoning, summaries) — zero-retention

US

OpenAI, LLC

Embeddings + transcription fallback — zero-retention

US
`;

export default content;
